import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MenuWaffleFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.6 11.02V4.56H11.06V11.02H4.6ZM12.94 11.02V4.56H19.4V11.02H12.94ZM4.6 19.36V12.9H11.06V19.36H4.6ZM12.94 19.36V12.9H19.4V19.36H12.94Z" />
    </SvgIcon>
  );
});
